// Modulo creato per gestire la pianificazione degli interventi in base al numero di interventi dal pianificatore.
// Il campo *Fine al* con questa personalizzazione non è modificabile quindi va calcolato per poi essere passato al backend.
// E' calcolato in base al numero di interventi, alla data di inizio, l'orario di inizio e la frequenza di ripetizione che può essere giornaliera o settimanale.

import errorManager from '@/rollbar.js';

// GESTIONE DELLA DATA FINO AL QUANDO LA RIPETIZIONE E' *GIORNALIERA*
const updateRepeatsEndOnDailyRepeat = (repeatsEndOn, nrInterventi, repeatsOnHours, from, fromTime, repeatsEndOnHidden, repeatsEveryN) => {
  if (repeatsEndOn.value && nrInterventi.value !== '' && repeatsOnHours.some((hour) => hour.checked)) {
    setRepeatsEndOnDaily(nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
  }
};

const dailyRepeat = (nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN) => {
  // 1. seleziono le checkbox con le ore
  // 2. se almeno una checkbox è selezionata, abilito il campo per il numero di interventi
  // 3. se il campo per il numero di interventi e la frequenza di ripetizione sono valorizzati, calcolo la data di fine
  // 4. se cambia l'intervallo dei giorni di ripetizione, calcolo la data di fine
  const repeatsOn = document.querySelector('#repeats_each_hour');
  const repeatsOnHours = Array.from(document.querySelectorAll('.refresh.hour'));
  repeatsOn.onchange = () => {
    if (repeatsOn.checked) {
      repeatsOnHours.forEach((hour) => {
        hour.onchange = () => {
          nrInterventi.disabled = !repeatsOnHours.some((hour) => hour.checked);
          updateRepeatsEndOnDailyRepeat(repeatsEndOn, nrInterventi, repeatsOnHours, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
        };
      });
    }
  };

  repeatsEveryN.oninput = () => {
    if (repeatsEveryN.value !== '' && nrInterventi.value !== '' && repeatsOnHours.some((hour) => hour.checked)) {
      updateRepeatsEndOnDailyRepeat(repeatsEndOn, nrInterventi, repeatsOnHours, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
    }
  };
};

const setRepeatsEndOnDaily = (nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN) => {
  // 1. prendo la data di inizio e l'orario di inizio
  // 2. seleziono le finestre orarie selezionate dall'utente
  // 3. se il valore inserito di fromTime è maggiore del minimo valore selezionato, riassegno il valore di fromTime
  const fromValue = from.value;
  const [day, month, year] = fromValue.split('/');
  const fromDate = new Date(`${year}-${month}-${day}`);
  const [hour, minutes] = fromTime.value.split(':');
  const date = new Date(fromDate);

  const repeatsOnHours = document.querySelectorAll('.refresh.hour');
  const repeatsOnHoursValues = Array.from(repeatsOnHours)
    .filter((hour) => hour.checked)
    .map((hour) => hour.value);

  const minHourInt = repeatsOnHoursValues.map((hour) => parseInt(parseInt(hour.split(':').join('')))).sort((a, b) => a - b)[0];
  const fromTimeInt = parseInt(fromTime.value.split(':').join(''));

  if (minHourInt < fromTimeInt) {
    fromTime.value = repeatsOnHoursValues[0];
  }

  date.setHours(hour);
  date.setMinutes(minutes);

  // 4. calcolo il numero di giorni necessari per completare il numero di interventi
  // 5. incremento la data di fine in base al numero di giorni necessari
  // 6. setto la data di fine, la trasformo in stringa e la inserisco nel campo *Fine al* e nel campo nascosto per il backend

  const daysNeeded = Math.ceil(parseInt(nrInterventi.value) / repeatsOnHoursValues.length);

  date.setDate(date.getDate() + (daysNeeded - 1) * parseInt(repeatsEveryN.value));

  const [newYear, newMonth, newDay] = date.toISOString().split('T')[0].split('-');
  repeatsEndOn.value = `${newDay}/${newMonth}/${newYear}`;
  repeatsEndOnHidden.value = `${newDay}/${newMonth}/${newYear}`;
};

// GESTIONE DELLA DATA FINO AL QUANDO LA RIPETIZIONE E' *SETTIMANALE*
const updateEndDateOnWeeklyRepeat = (
  repeatsEndOn,
  nrInterventi,
  weekDays,
  from,
  fromTime,
  repeatsEndOnHidden,
  repeatsEveryN,
  fromWeekDay,
  repeatsRule,
) => {
  // 1. se la regola selezionata non è weekly, non calcolo la data di fine
  // 2. se la regola selezionata è weekly, calcolo la data di fine in base ai giorni della settimana selezionati
  // 3. se il giorno della settimana selezionato non coincide con il giorno della settimana in cui cade il from, resetto i giorni della settimana
  //    + alert per l'utente
  // 4. se almeno un giorno della settimana è selezionato, abilito il campo per il numero di interventi
  // 5. se il campo per il numero di interventi e la frequenza di ripetizione sono valorizzati, calcolo la data di fine
  // 6. se il campo per il numero di interventi e la frequenza di ripetizione non sono valorizzati, disabilito il campo per il numero di interventi

  if (repeatsRule !== 'weekly') return;

  const weekDaysChecked = weekDays.filter((day) => day.checked).map((day) => parseInt(day.value));
  if (repeatsRule === 'weekly' && !weekDaysChecked.includes(fromWeekDay)) {
    alert(
      'Il giorno della settimana selezionato non coincide con nessun giorno della settimana selezionato. Riselezionare il giorno della settimana o il giorno di inizio.',
    );
    weekDays.forEach((day) => {
      day.checked = false;
    });
  }
  if (weekDays.some((day) => day.checked)) {
    nrInterventi.disabled = false;

    repeatsEveryN.oninput = () => {
      if (repeatsEveryN.value !== '' && nrInterventi.value !== '' && weekDays.some((day) => day.checked)) {
        setRepeatsEndOnWeekly(nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
      } else {
        nrInterventi.disabled = true;
        repeatsEndOn.value = '';
        repeatsEndOnHidden.value = '';
      }
    };

    if (repeatsEveryN.value !== '' && nrInterventi.value !== '') {
      setRepeatsEndOnWeekly(nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
    }
  } else {
    nrInterventi.disabled = true;
    nrInterventi.value = '';
    repeatsEndOn.value = '';
    repeatsEndOnHidden.value = '';
  }
};

const weeklyRepeat = (nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN, repeatsRule) => {
  // 1. seleziono le checkbox per i giorni della settimana + la checkbox per selezionare tutti i giorni
  // 2. selezione la data di inizio e calcolo il giorno della settimana
  // 3. aggiornamento della data di fine se è checkato il campo *Tutti i giorni* oppure se è checkato almento un giorno a settimana

  const allWeek = document.querySelector('#all_day_week');
  const weekDays = Array.from(document.querySelectorAll('.refresh.day_week'));
  const fromValue = from.value;
  const [day, month, year] = fromValue.split('/');
  const fromDate = new Date(`${year}-${month}-${day}`);
  const fromWeekDay = fromDate.getDay();
  allWeek.onchange = () => {
    weekDays.forEach((day) => {
      day.checked = allWeek.checked;
    });
    updateEndDateOnWeeklyRepeat(
      repeatsEndOn,
      nrInterventi,
      weekDays,
      from,
      fromTime,
      repeatsEndOnHidden,
      repeatsEveryN,
      fromWeekDay,
      repeatsRule,
    );
  };

  weekDays.forEach((day) => {
    day.onchange = () => {
      if (weekDays.every((day) => day.checked)) {
        allWeek.checked = true;
      } else {
        allWeek.checked = false;
      }
      updateEndDateOnWeeklyRepeat(
        repeatsEndOn,
        nrInterventi,
        weekDays,
        from,
        fromTime,
        repeatsEndOnHidden,
        repeatsEveryN,
        fromWeekDay,
        repeatsRule,
      );
    };
  });

  // il ricalcolo deve essere richiamato ogni volta che cambia il numero di interventi oppure se cambia la frequenza di ripetizione

  nrInterventi.oninput = () =>
    updateEndDateOnWeeklyRepeat(
      repeatsEndOn,
      nrInterventi,
      weekDays,
      from,
      fromTime,
      repeatsEndOnHidden,
      repeatsEveryN,
      fromWeekDay,
      repeatsRule,
    );
  repeatsEveryN.onchange = () =>
    updateEndDateOnWeeklyRepeat(
      repeatsEndOn,
      nrInterventi,
      weekDays,
      from,
      fromTime,
      repeatsEndOnHidden,
      repeatsEveryN,
      fromWeekDay,
      repeatsRule,
    );
};

// Funzione che calcola la data di fine per la ripetizione settimanale
const setRepeatsEndOnWeekly = (nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN) => {
  const fromValue = from.value;
  const [day, month, year] = fromValue.split('/');
  const fromDate = new Date(`${year}-${month}-${day}`);
  const [hour, minutes] = fromTime.value.split(':');
  const date = new Date(fromDate);
  const nrInterventiValue = parseInt(nrInterventi.value);
  const weeksInterval = parseInt(repeatsEveryN.value);

  date.setHours(hour);
  date.setMinutes(minutes);

  // Quando si seleziona l'opzione settimanale, compaiono le checkbox con i giorni della settimana + la checkbox per selezionare tutti i giorni
  // 1. seleziono i giorni
  // 2. ciclo sul numero dei giorni di intervento e decremento il contatore
  // 3. se il giorno della settimana corrisponde a quello selezionato, decremento il contatore e incremento il contatore dei giorni della settimana
  // 4. se il contatore dei giorni della settimana è maggiore di 0, incremento la data di 7 giorni * il numero di settimane di intervallo
  // 5. se il contatore dei giorni della settimana è 0, incremento la data di 1 giorno
  // 6. setto la data di fine, la trasformo in stringa e la inserisco nel campo *Fine al* e nel campo nascosto per il backend

  const weekDays = Array.from(document.querySelectorAll('.refresh.day_week'))
    .filter((day) => day.checked)
    .map((day) => parseInt(day.value));

  let remainingInterventi = nrInterventiValue;
  let daysCountedInCurrentWeek = 0;
  const initialDayOfWeek = fromDate.getDay();

  while (remainingInterventi > 0) {
    if (weekDays.includes(date.getDay())) {
      remainingInterventi--;
      daysCountedInCurrentWeek++;
    }

    if (remainingInterventi > 0) {
      date.setDate(date.getDate() + 1);

      if (date.getDay() === initialDayOfWeek) {
        if (daysCountedInCurrentWeek > 0) {
          date.setDate(date.getDate() + 7 * (weeksInterval - 1));
          daysCountedInCurrentWeek = 0;
        }
      }
    }
  }

  const [newYear, newMonth, newDay] = date.toISOString().split('T')[0].split('-');
  repeatsEndOn.value = `${newDay}/${newMonth}/${newYear}`;
  repeatsEndOnHidden.value = `${newDay}/${newMonth}/${newYear}`;
};

// Check repeats on: può essere giornaliero o settimanale (il default è mai per il singolo intervento, in questo caso non serve calcolare il campo fino al)
const checkRepeatOn = (repeats, nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN) => {
  let currentRule = null;
  // se cambia il tipo di ripetizione, ho bisogno di resettare i campi e rimuovere i listener per evitare che si sovrappongano
  repeats.onchange = () => {
    const repeatsRule = repeats.value;
    if (currentRule === 'daily') {
      const repeatsOn = document.querySelector('#repeats_each_hour');
      const repeatsOnHours = Array.from(document.querySelectorAll('.refresh.hour'));
      repeatsOn.onchange = null;
      repeatsOnHours.forEach((hour) => (hour.onchange = null));
      repeatsEveryN.onchange = null;
    } else if (currentRule === 'weekly') {
      const allWeek = document.querySelector('#all_day_week');
      const weekDays = Array.from(document.querySelectorAll('.refresh.day_week'));
      allWeek.onchange = null;
      weekDays.forEach((day) => (day.onchange = null));
      nrInterventi.oninput = null;
      repeatsEveryN.onchange = null;
    }
    nrInterventi.value = '';
    repeatsEndOn.value = '';
    repeatsEndOnHidden.value = '';
    // se cambia il tipo di ripetizione, cambio la corrispondente funzione di calcolo
    switch (repeatsRule) {
      case 'never':
        break;
      case 'daily':
        dailyRepeat(nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
        break;
      case 'weekly':
        weeklyRepeat(nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN, repeatsRule);
        break;
    }

    currentRule = repeatsRule;
  };
};

// funzione che riempie il campo *Fine al* in base al numero di interventi, la data di inizio, l'orario di inizio e la frequenza di ripetizione
const setRepeatsEndOn = (nrInterventi, repeatsEndOn, from, fromTime, repeats, repeatsEndOnHidden, repeatsEveryN) => {
  const repeatsValue = repeats.value;
  switch (repeatsValue) {
    case 'daily': {
      setRepeatsEndOnDaily(nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
      break;
    }
    case 'weekly': {
      setRepeatsEndOnWeekly(nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
      break;
    }
  }
};

// da haml su epersonam (partial: '_modal_for_planning' arriva un oggetto con i selector dei campi da gestire)
const calculateRepeatsEndOn = (parametersObject) => {
  // nr interventi
  const nrInterventi = document.querySelector(parametersObject.nrInterventi);
  // fino al
  const repeatsEndOn = document.querySelector(parametersObject.repeatsEndOn);
  // data/ora prevista
  const from = document.querySelector(parametersObject.fromPlanner);
  const fromTime = document.querySelector(parametersObject.fromPlannerTime);
  // ripetizione: MAI, Giorni, Settimane
  const repeats = document.querySelector(parametersObject.repeats);
  // ogni N giorni/settimane
  const repeatsEveryN = document.querySelector(parametersObject.repeatsEveryN);
  // campo nascosto per il valore di fine ripetizione: per form
  const repeatsEndOnHidden = document.querySelector(parametersObject.repeatsEndOnHidden);
  // i campi from, fromTime e repeats sono richiesti per abilitare i campi richiesti per il calcolo
  const requiredFields = [from, fromTime, repeats];

  requiredFields.forEach((field) => {
    field.onchange = () => {
      if ([from, fromTime].every((field) => field.value)) {
        repeats.disabled = false;
        repeatsEveryN.disabled = false;
      } else {
        repeats.disabled = true;
        repeatsEveryN.disabled = true;
      }
      if (requiredFields.every((field) => field.value)) {
        checkRepeatOn(repeats, nrInterventi, repeatsEndOn, from, fromTime, repeatsEndOnHidden, repeatsEveryN);
      }
    };
  });
  nrInterventi.oninput = () => setRepeatsEndOn(nrInterventi, repeatsEndOn, from, fromTime, repeats, repeatsEndOnHidden, repeatsEveryN);
};

const init = (parametersObject) => {
  try {
    calculateRepeatsEndOn(parametersObject);
  } catch (e) {
    errorManager(e);
  }
};

window.PlanningNrGads = {
  init: init,
};
